import styled from "styled-components";

export const RootContainer = styled.div`
  padding: 24px 16px;
`;

export const Box = styled.div`
  padding: 16px 0;
  border-radius: 5px;
  border: 1px solid #e1cce0;
  background-color: #fff;
  filter: drop-shadow(0px 3px 6px #e1cce0);
  text-align: center;
`;

export const BoxTitle = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #71207c;

  @media screen and (max-width: 330px) {
    font-size: 12px;
  }
`;

export const BoxText = styled.div`
  padding-top: 10px;
  font-size: 18px;
  font-weight: ${(props) => (props.color === "light" ? "500" : "bold")};
  color: #000000;

  @media screen and (max-width: 330px) {
    font-size: 16px;
  }
`;

export const BoxWrapper = styled.div`
  display: flex;
  grid-gap: 16px;
  padding-top: 16px;

  > div {
    flex: 1;
  }
`;

export const ListWrapper = styled.div`
  padding-top: 32px;
`;

export const Title = styled.div`
  padding-bottom: 16px;
  font-size: 18px;
  font-weight: bold;
  color: #000000;

  @media screen and (max-width: 330px) {
    font-size: 16px;
  }
`;

export const Item = styled.div`
  padding: 16px;
  border-radius: 4px;
  background-color: #e1cce0;
  display: flex;
  flex-direction: column;
  grid-gap: 8px;
  margin-bottom: 13px;
`;

export const ItemText = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: #000;

  @media screen and (max-width: 330px) {
    font-size: 14px;
  }
`;

export const LightText = styled.div`
  font-size: 14px;
  font-weight: normal;
  color: #815f71;

  @media screen and (max-width: 330px) {
    font-size: 12px;
  }
`;

export const DateText = styled.div`
  font-size: 14px;
  font-weight: normal;
  color: ${(props) => (props.status === "expired" ? "#AF0000" : "#09820D")};

  @media screen and (max-width: 330px) {
    font-size: 12px;
  }
`;

export const SpinWrapper = styled.div`
  text-align: center;
`;

export const EmptyText = styled.div`
  text-align: center;
  font-size: 13px;
`;
